import { getJWT, setJWT } from './helpers/jwt';
import { initSentry } from './configs/initSentry';

export const initApp = () => {
    const { jwtFromUrl } = getJWT();
    if (jwtFromUrl) setJWT(jwtFromUrl);

    initSentry();
};
